import PropTypes from 'prop-types';
import React from 'react';
import { M } from '@dashboard-experience/mastodon';

import { computeAssessStatusForCharges } from '@dashboard-experience/utils';
import Charge from '../Charge/Criminal';
import Attribute from '../Attribute';
import { getChargeTitle, getChargeDate } from '../lib/screenings';
import { chargesAssessmentToDashboardFormat } from '../utils';

const CRIMINAL_ATTRS = Object.freeze([
  'caseNumber',
  'fileDate',
  'courtOfRecord',
  'courtJurisdiction',
  'arrestingAgency',
  'county',
  'state',
  'fullName',
  'dob',
  'yob',
]);

const getAssessStatusForCharges = (assessmentEnabled, charges) => {
  return !!charges && assessmentEnabled
    ? computeAssessStatusForCharges(chargesAssessmentToDashboardFormat(charges))
    : null;
};

const CriminalRecord = ({ record, assessmentEnabled }) => {
  const chargesToDisplay = (record.charges || []).concat(
    record.filteredByPositiveAdjudicationCharges || [],
    record.chargesHiddenByAssess || [],
  );
  const hasCharges = chargesToDisplay.length > 1;
  const recordStatus = getAssessStatusForCharges(
    assessmentEnabled,
    record?.charges,
  );

  return (
    <div className='criminal-record mb-4'>
      <div className='mb-3'>
        <hr className='mb-2 mt-2' />
        <div className='d-flex'>
          {recordStatus && (
            <M.StatusIcon
              className='mr-2'
              icon={recordStatus}
              data-testid='record-status-icon'
            />
          )}
          <span className='text-uppercase'>{getChargeTitle(record)}</span>
          <span className='ml-auto'>{getChargeDate(record)}</span>
        </div>
        <hr className='mb-2 mt-2' />
      </div>

      <div className='mb-4 mt-4'>
        {CRIMINAL_ATTRS.map((key, i) => (
          <Attribute
            key={`attribute-${i + 1}`}
            attr={key}
            value={record[key]}
          />
        ))}
      </div>

      {hasCharges && <hr />}

      {chargesToDisplay.map((charge, i) => (
        <div key={`div-${i + 1}`}>
          <Charge
            charge={charge}
            index={i}
            assessmentEnabled={assessmentEnabled}
          />
          <hr />
        </div>
      ))}
    </div>
  );
};

CriminalRecord.propTypes = {
  record: PropTypes.object.isRequired,
  assessmentEnabled: PropTypes.bool,
};

CriminalRecord.defaultProps = {
  assessmentEnabled: false,
};

export default CriminalRecord;
